import * as React from 'react';
import FormField, { BaseFormFieldProps } from './FormField';
import { InputProps, TextInput } from '../input/basicInputs';

export interface TextInputFormFieldProps extends BaseFormFieldProps, InputProps {}

class TextInputFormField extends React.Component<TextInputFormFieldProps> {
  render() {
    return <FormField {...this.props}>{({ input }) => <TextInput {...input} />}</FormField>;
  }
}

export default TextInputFormField;
